import { createStructuredSelector } from 'reselect';
import * as selectors from '../App/selector';

export const mapStateToProps = createStructuredSelector({
    selectedId: selectors.selectSelectedId,
    routers: selectors.selectRouters,
    availableRouterIds: selectors.selectAvailableRouterIds,
    disableBooking: selectors.selectDisableBooking,
});

export type State = ReturnType<typeof mapStateToProps>;
